import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import usePostHook from "../../customHooks/usePostHook";
import createBranchServiceValidationForm from "../../utils/validationSchemas";
import TextField from "../Reusable/TextInput";
import APIS from "../../constant/Endpoint";
import Button from "../Reusable/Button";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import usePatchHook from "../../customHooks/usePatchHook";
import { useParams } from "react-router-dom";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import useGetHook from "../../customHooks/useGetHook";

const EditBranch = ({
  setIsOpen,
  branchLoading,
  refetch,
  id,
  handleEditBranch,
}) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    setValue,
    setError,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createBranchServiceValidationForm),
    defaultValues: async () => {
      let data: any = await refetch();
      return {
        ...data?.data,
      };
    },
  });

  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEditBranch}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={branchLoading}
    >
      <div className={tw`grid md:grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"Code"}
          register={register("code")}
          errors={errors?.code}
        />
        <TextField
          label={"Name"}
          register={register("name")}
          errors={errors?.name}
        />
        <TextField
          label={"Email"}
          register={register("primary_email")}
          errors={errors?.primary_email}
        />
        <PhoneNumberField
          control={control}
          label={"Primary Phone"}
          name={"primary_contact"}
          errors={errors?.primary_contact}
        />
        <TextField
          label={"VAT/PAN"}
          register={register("vat_pan")}
          errors={errors?.vat_pan}
        />
      </div>
    </FormLayout>
  );
};

export default EditBranch;
